import React, { useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import { LayoutProvider } from './context/LayoutContext';
import { useAuth } from './context/AuthContext';
import LoginPage from './components/LoginPage';
import NotificationPage from './components/Notifications/NotificationPage';
import WindowsPage from './components/windows/WindowsPage';
import ApplePage from './components/ApplePage';
import ChromePage from './components/ChromePage';
import AndroidInstallPage from './components/AndroidPage';
import ProtectedRoute from './components/ProtectedRoute';
import NavigationBar from './components/NavigationBar';
import './App.css';
import SupportModal from './components/modals/SupportModal';
import Support from './components/SupportPage';
import AdminPage from './components/AdminPage';
import AdminPageEditor from './components/AdminPageEditor';

function App() {
  const [modalOpen, setModalOpen] = useState(false);
  const { token } = useAuth();
  const isLoginPage = window.location.pathname === '/esafe/login';
  const isAndroidPage = window.location.pathname === '/esafe/android';

  return (
    <LayoutProvider>
      {token && <NavigationBar />}
      <div className={isLoginPage ? '' : `main-content ${isAndroidPage ? 'android' : 'desktop'}`}>
        <div className="app">
          <Routes>
            
            <Route path="/login" element={<LoginPage />} />
            <Route path="/admin/editor" element={<AdminPageEditor />} />
            <Route path="/notification" element={<ProtectedRoute><NotificationPage /></ProtectedRoute>} />
            <Route path="/notifications/:documentName" element={<ProtectedRoute><NotificationPage /></ProtectedRoute>} />
            <Route path="/windows" element={<ProtectedRoute><WindowsPage /></ProtectedRoute>} />
            <Route path="/windows/:documentName" element={<ProtectedRoute><WindowsPage /></ProtectedRoute>} />
            <Route path="/mac" element={<ProtectedRoute><ApplePage /></ProtectedRoute>} />
            <Route path="/mac/:documentName" element={<ProtectedRoute><ApplePage /></ProtectedRoute>} />
            <Route path="/chrome" element={<ProtectedRoute><ChromePage /></ProtectedRoute>} />
            <Route path="/chrome/:documentName" element={<ProtectedRoute><ChromePage /></ProtectedRoute>} />
            <Route path="/android" element={<ProtectedRoute><AndroidInstallPage /></ProtectedRoute>} />
            <Route path="/supports" element={<ProtectedRoute><Support /></ProtectedRoute>} /> 
            <Route path="/support/:documentName" element={<ProtectedRoute><Support /></ProtectedRoute>} /> 
            <Route path="/admin" element={<ProtectedRoute><AdminPage /></ProtectedRoute>} />
           
          </Routes>
          <SupportModal isOpen={modalOpen} onClose={() => setModalOpen(false)} />
        </div>
      </div>
    </LayoutProvider>
  );
}

export default App;
